import gql from 'graphql-tag';
import { disclosureFragment } from '../../graphql/queries/selective-disclosure.query';

export const TOP_TEN_HOLDINGS_BOND = gql`
    query TopTenHoldingsBond($ticker: String!) {
        mutualFund(ticker: $ticker) {
            name: shortName
            inceptionDate
            broadAssetClass
            selectiveDisclosures {
                quarterly {
                    ...Disclosure
                }
                monthly {
                    ...Disclosure
                }
            }
        }
    }
    ${disclosureFragment}
`;
